<ng-container *ngIf="isLoading; else showPage">
  <div class="app-spinner d-flex justify-content-center align-items-center">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-container>

<ng-template #showPage>
  <ng-container *ngIf="sessionData">
    <div class="candidate-report" id="candidate-report-content">
      <div id="pdf-summary-section">
      <div class="page-header">
        <div class="left">
          <button class="back-btn" routerLink="/proctoring-dashboard/dashboard"
            data-html2canvas-ignore>
            <i class="bi bi-arrow-left"></i>
            <span>Back</span>
          </button>

          <div class="title-section">
            <h2>Candidate Proctoring Report</h2>
          </div>
        </div>

        <div class="actions">
          <!-- <button class="secondary-btn">
        <i class="bi bi-share"></i>
        Share Report
      </button> -->

          <button
            class="primary-btn"
            (click)="downloadReport()"
            [disabled]="isDownloading"
             data-html2canvas-ignore
          >
            <i class="fa fa-spinner fa-spin" *ngIf="isDownloading"></i>
            <i class="bi bi-download" *ngIf="!isDownloading"></i>
            {{ isDownloading ? "Downloading..." : "Download Report" }}
          </button>
        </div>
      </div>

      <div class="top-section-grid">
        <div class="card summary-card">
          <div class="divider-full"></div>

         <div class="info-columns">
  <div class="info-col">
    <span class="col-title">Candidate Information</span>

    <div class="candidate-info-row">
      <div class="info-item">
        <label>CANDIDATE NAME</label>
        <span>{{ sessionData.summary.candidateName || "N/A" }}</span>
      </div>

      <div class="info-item">
        <label>EMAIL</label>
        <ng-container *ngIf="sessionData.summary.candidateEmail; else noEmail">
        <span>
          <i class="bi bi-envelope"></i>
          {{ sessionData.summary.candidateEmail }}
        </span>
        </ng-container>
        <ng-template #noEmail><span>N/A</span></ng-template>
      </div>

      <div class="info-item">
        <label>CANDIDATE ID</label>
        <span>{{ sessionData.summary.candidateId || "N/A" }}</span>
      </div>
    </div>
  </div>
</div>
          <div class="divider"></div>

          <div class="info-row-bottom session-section mt-4">
            <div class="col-title mb-3">Session Information</div>
            <div class="session-info-grid">
              <div class="info-item">
                <label>SESSION ID</label>
                <span>{{ sessionData.sessionId || "N/A" }}</span>
              </div>
              <div class="info-item ms-5">
                <label>STARTED AT</label>
                <span>{{
                  sessionData.summary.startedAt
                    ? (sessionData.summary.startedAt | date: "yyyy-MM-dd HH:mm")
                    : "N/A"
                }}</span>
              </div>
              <div class="info-item">
                <label>ENDED AT</label>
                <span>{{
                  sessionData.summary.endedAt
                    ? (sessionData.summary.endedAt | date: "yyyy-MM-dd HH:mm")
                    : "N/A"
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card right-summary-card">
          <div class="col-title">SESSION SUMMARY</div>

          <div class="circular-progress-container">
            <div class="progress-ring">
              <svg
                viewBox="0 0 36 36"
                [attr.class]="'circular-chart ' + integrityColorClass"
              >
                <path
                  class="circle-bg"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                  class="circle"
                  [attr.stroke-dasharray]="integrityScoreDashArray"
                  [style.stroke]="integrityStrokeColor"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                />
              </svg>
              <div class="progress-text">
                <h2>{{ hasIntegrityScore ? integrityScore + "%" : "0%" }}</h2>
                <span
                  [ngClass]="integrityTextColorClass"
                  *ngIf="hasIntegrityScore"
                  >{{ integrityStatus }}</span
                >
              </div>
            </div>
          </div>

          <div class="divider-full"></div>

          <div class="summary-list">
            <div class="list-item">
              <span>Session Status</span>
              <span
                *ngIf="sessionData.summary.sessionStatus"
                  class="badge evidence-badge"
                  [ngClass]="{
                    'warning-light': sessionData.summary.sessionStatus.toUpperCase() === 'REQUESTED',
                    'danger-light': ['ABANDONED', 'TERMINATED'].includes(sessionData.summary.sessionStatus.toUpperCase()),
                    'success-light': ['COMPLETED', 'ACTIVE'].includes(sessionData.summary.sessionStatus.toUpperCase())
                  }"
                ><div class="dot"></div>
                {{ sessionData.summary.sessionStatus }}</span
              >
              <span *ngIf="!sessionData.summary.sessionStatus">-</span>
            </div>
            <div class="list-item">
              <span>Total Violations</span>
              <span class="fw-bold">{{
                sessionData.summary.totalViolations !== null &&
                sessionData.summary.totalViolations !== undefined
                  ? sessionData.summary.totalViolations
                  : "N/A"
              }}</span>
            </div>
            <div class="list-item">
              <span>Duration</span>
              <span class="fw-bold">{{ formatDuration(sessionData.summary.durationSeconds) }}</span>
            </div>
            <div class="list-item">
              <span>Assessment</span>
              <span
                class="fw-bold"
                >{{ sessionData.summary.proctoringEvaluationOnId || "N/A" }}</span
              >
            </div>
            <div class="list-item">
              <span>Termination Reason</span>
              <span class="fw-bold">{{sessionData.summary.terminationReason || "N/A"}}</span>
            </div>
          </div>
        </div>
          </div>
      </div>

      <div class="card captured-evidence-card">
        <div
          id="pdf-evidence-header"
          class="card-header border-none d-flex justify-content-between align-items-center"
        >
          <div>
            <h3>Captured Evidence(s)</h3>
            <p>Snapshots captured at the moment of each detected violation</p>
          </div>
          <div class="items-badge">
            <div class="dot gray-dot"></div>
            {{ violationsWithEvidence.length || 0 }} Item(s)
          </div>
        </div>

<div *ngFor="let page of evidencePages; let pageIndex = index; trackBy: trackByPage" class="evidence-page" [attr.id]="'pdf-evidence-page-' + pageIndex">
  <div *ngIf="pageIndex > 0" class="page-break"></div>
  <div class="evidence-grid">
    <div
      class="evidence-item"
      *ngFor="let violation of page; trackBy: trackByViolation">

      <div class="evidence-image">
          <img
            [src]="violation.evidenceUrl"
            [alt]="violation.eventType"
            crossorigin="anonymous"
            style="cursor: pointer;"
            (click)="openSnapshotPreview(violation.evidenceUrl)"/>
      </div>

      <div class="evidence-footer">
        <div class="evidence-title-row">
          <span class="evidence-title">
            {{ violation.eventType || "N/A" }}
          </span>

          <span
            class="badge evidence-badge"
            [ngClass]="{
              'warning-light': violation.severity === 'MEDIUM',
              'danger-light': violation.severity === 'HIGH' || violation.severity === 'CRITICAL',
              'success-light': violation.severity === 'LOW'
            }">

            <div
              class="dot"
              [ngClass]="{
                'warning-dot': violation.severity === 'MEDIUM',
                'danger-dot': violation.severity === 'HIGH' || violation.severity === 'CRITICAL',
                'success-dot': violation.severity === 'LOW'
              }">
            </div>

            {{ violation.severity ? (violation.severity | titlecase) : "N/A" }}
          </span>
        </div>
        <div class="evidence-timestamp">
          {{
            violation.timestamp
              ? (violation.timestamp | date:'hh:mm:ss a')
              : 'N/A'
          }}
        </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="pdf-evidence-empty"
          *ngIf="!violationsWithEvidence?.length"
          class="empty-state p-4 text-muted"
        >
          No snapshots available
        </div>
      </div>

      <div class="card session-recording-card mt-4"  data-html2canvas-ignore>
        <div class="card-header border-none">
          <div>
            <h3>Session Recording</h3>
            <p>Full proctored session playback</p>
          </div>
        </div>

        <div class="recording-grid">
          <div
            class="recording-item"
            *ngFor="let recording of sessionData.recordings; let i = index"
          >
            <div class="recording-video">
              <video
                *ngIf="recording.url"
                controls
                [src]="recording.url"
              ></video>
              <div *ngIf="!recording.url" class="video-placeholder-new">
                <div class="play-btn-circle">
                  <i class="bi bi-play-fill"></i>
                </div>
              </div>
            </div>
            <div class="recording-footer">
              <div class="recording-info">
                <span class="recording-title">{{
                  recording.recordingType || "N/A"
                }}</span>
                <span class="recording-meta text-muted">
                  {{ formatDuration(recording.durationSeconds) }}
                  ·
                  {{
                    recording.sizeBytes !== null &&
                    recording.sizeBytes !== undefined
                      ? (recording.sizeBytes / 1024 / 1024 | number: "1.0-0") +
                        " MB"
                      : "N/A"
                  }}
                  ·
                  {{
                    recording.startedAt
                      ? (recording.startedAt | date: "yyyy-MM-dd HH:mm")
                      : "N/A"
                  }}
                </span>
              </div>
              <div class="recording-actions">
                <button class="secondary-btn small-btn">
                  <i class="bi bi-play"></i> Play
                </button>
                <button class="secondary-btn small-btn icon-only">
                  <i class="bi bi-download"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="!sessionData.recordings?.length"
          class="empty-state p-4 text-muted"
        >
          No screen recording available
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<div
  class="snapshot-preview-modal"
  *ngIf="previewSnapshotUrl"
  (click)="closeSnapshotPreview()"
>
  <button class="close-btn" (click)="closeSnapshotPreview()">
    <i class="bi bi-x-lg"></i>
  </button>
  <div class="snapshot-preview-container" (click)="$event.stopPropagation()">
    <img [src]="previewSnapshotUrl" alt="Snapshot Preview" />
  </div>
</div>